import React from "react";

const Dropdown = ({ subMenu, renderItem }) => {
  return (
    <div className="absolute left-0 w-[200px] invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-all duration-200 ease-in-out z-50">
      <div
        className="bg-primary-accent drop-shadow-md overflow-hidden relative pb-10 angle-bottom mt-4 border-x border-secondary-accent"
        role="menu"
        aria-orientation="vertical"
      >
        <ul className="py-2" role="none">
          {subMenu.map((item) => (
            <li key={item.id} role="none">
              <div
                className="px-4 py-2 hover:bg-secondary-accent transition-colors duration-150"
                role="menuitem"
              >
                {renderItem(item)}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Dropdown;
